/* @flow */

import { replaceObject } from '../lib';
import type { Component, ComponentDriverType } from '../component/component';

/* eslint-disable new-cap, object-shorthand */

type Angular2Injection = {};

type Angular2Component = {};

type Angular2Module = {};

type Angular2 = {
    Component : ({ selector : string, template : string, inputs : Array<string> }) => {
        Class : ({ constructor : Array<Angular2Injection | Function>, ngOnInit : () => void, ngOnChanges : () => void }) => Angular2Component
    },
    NgModule : ({ declarations : Array<Angular2Component>, exports : Array<Angular2Component> }) => {
        Class : ({ constructor : () => void }) => Angular2Module
    },
    ElementRef : Angular2Injection,
    NgZone : Angular2Injection
};


export let angular2 : ComponentDriverType<*, Angular2> = {

    global() {

    },

    register(xcomponent : Component<*>, { Component : AngularComponent, NgModule, ElementRef, NgZone }) : Angular2Module {

        xcomponent.log('initializing angular2 component');

        let getProps = (component) => {
            return replaceObject({ ...component.internalProps, ...component.props }, (value, key, fullKey) => {
                if (typeof value === 'function') {
                    return function() : void {
                        return component.zone.run(() => value.apply(this, arguments));
                    };
                }
            });
        };

        const ComponentInstance =
            AngularComponent({
                selector: xcomponent.tag,
                template: '<div></div>',
                inputs: ['props']
            })
            .Class({
                constructor: [ElementRef, NgZone, function(elementRef, zone) {
                    this.elementRef = elementRef;
                    this.zone = zone;
                }],
                ngOnInit: function () {
                    const targetElement = this.elementRef.nativeElement;
                    const parent = xcomponent.init(getProps(this), null, targetElement);
                    parent.render(targetElement);
                    this.parent = parent;
                },
                ngOnChanges: function() {
                    if (this.parent) {
                        this.parent.updateProps(getProps(this));
                    }
                }
            });


        const ModuleInstance = NgModule({
            declarations: [ComponentInstance],
            exports: [ComponentInstance]
        })
        .Class({
            constructor: function () {

            }
        });

        return ModuleInstance;
    }
};



// WEBPACK FOOTER //
// ./node_modules/xcomponent/src/drivers/angular2.js